import React from 'react';
import { adminStripeAPI } from '../../services/api';
import StripeSyncButton from './StripeSyncButton';

const plural = (n, word) => `${n ?? 0} ${word}${n === 1 ? '' : 's'}`;

const finishedAt = (body) => body?.last_run?.finished_at ?? null;

// The job is done once the cached last_run carries a finished_at that differs from
// the one the POST saw (a null baseline means "never ran": any finished_at counts).
const isDone = (initial, latest) => {
  const now = finishedAt(latest);
  return now !== null && now !== finishedAt(initial);
};

const renderResult = ({ data, latest, done, gaveUp }) => {
  if (done && latest?.last_run) {
    const run = latest.last_run;
    if (run.error) return `Refund sync failed (${run.error}). Check the server logs.`;
    return `Resolved ${plural(run.sessions_resolved, 'session')}, applied ${plural(run.refunds_applied, 'refund')}, skipped ${run.skipped ?? 0}.`;
  }
  // queued false: the server refused a second run; we still poll the running one.
  const queued = data?.queued === false
    ? 'A refund sync is already running'
    : `Refund sync queued (${plural(data?.sessions_pending, 'session')} to resolve)`;
  return gaveUp ? `${queued}. Still running; check back later.` : `${queued}.`;
};

const POLL = {
  request: () => adminStripeAPI.syncRefundsStatus(),
  isDone,
  intervalMs: 3000,
  maxAttempts: 20,
};

/**
 * "Sync refunds": queues the Stripe refund backfill (POST /admin/stripe/sync_refunds),
 * then polls GET /admin/stripe/sync_refunds until the run finishes and shows its counts.
 */
const RefundSyncButton = ({ className = 'flex flex-wrap items-center gap-3 mb-4' }) => (
  <StripeSyncButton
    label="Sync refunds"
    errorText="Refund sync failed."
    testIdPrefix="refund-sync"
    run={() => adminStripeAPI.syncRefunds()}
    renderResult={renderResult}
    poll={POLL}
    className={className}
  />
);

export default RefundSyncButton;
